'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('SleepMainCtrl', SleepMainCtrl);

  SleepMainCtrl.$inject = ['$state', '$q', 'sleepEntrySvc', 'actionPlanSvc', 'NotifyingSvc'];

  function SleepMainCtrl($state, $q, sleepEntrySvc, actionPlanSvc, NotifyingSvc) {
    var vm = this;
    vm.showPrintButton = false;
    var planStates = ['plan', 'schedule', 'schedule-edit'];
    var diaryStates = ['diary', 'calendar', 'entry', 'entry-summary'];

    //The various sleep router states do not follow the parent/child pattern, so we can't use ui-sref-active
    //These methods allow us to highlight the correct tab despite that

    function isPlanTab() {
      return planStates.find(matchesCurrentState);
    }

    function isDiaryTab() {
      return diaryStates.find(matchesCurrentState);
    }

    function matchesCurrentState(name) {
      return _.endsWith($state.current.name, name);
    }

    function getNavName() {
      if (isDiaryTab()) {
        return 'diary';
      }
      if (isPlanTab()) {
        return 'plan';
      }
      return 'plan';
    }

    vm.currentNavItem = getNavName();

    vm.$onInit = function () {
      $q.all([sleepEntrySvc.getMostRecentEntry(), actionPlanSvc.getMyPlan()]).then(function (data) {
        var sleepEntry = data[0];
        var actionItems = data[1];
        if (sleepEntry.length > 0 || actionItems.length > 0) {
          vm.showPrintButton = true;
        }
      });

      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.ENTRY_CREATED, function () {
        if (!vm.showPrintButton) {
          vm.showPrintButton = true;
        }
      });
      // workaround for md-nav-bar for accessibility
      var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
      navElement.attr('tabindex', '0');
    };
  }
})();